import { authenticatedAPI } from '../AuthenticatedAPI';
import { fundsResDto } from '@web/common';

export const getFunds = async () => {
  return authenticatedAPI.get('api/loyality-points/my-funds', fundsResDto);
};
